import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  TOKEN_USER,
  INFO_USER,
  LAST_PATH,
} from "./actionTypes";

export const loginUser = (token, history) => {
  return {
    type: LOGIN_USER,
    payload: { token, history },
  };
};

export const loginSuccess = (token) => {
  return {
    type: LOGIN_SUCCESS,
    payload: token,
  };
};

export const tokenUser = (token) => {
  return {
    type: TOKEN_USER,
    payload: { token },
  };
};

export const infoUser = (data) => {
  return {
    type: INFO_USER,
    payload: { data },
  };
};

export const lastPath = (data) => {
  return {
    type: LAST_PATH,
    payload: data,
  };
};

export const logoutUser = (history) => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  };
};

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
